export default {
    API_URL: process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:8080/api'
    //API_URL: process.env.NODE_ENV === 'production' ? '/api' : 'https://maraton-test.dokamar.cz/api'
}
